import { FloatingPlayerContext } from '@contexts/floating-player';
import { createContextWithSelector } from '@utils';

export const useFloatingPlayer = createContextWithSelector(
  FloatingPlayerContext,
  'useFloatingPlayer',
);
